import {
    CASES_GENERAL_DETAIL,
    CASES_GENERAL_INFORMATION_DETAIL,
    PQR_DETAIL,
    QUOTATION_DETAIL,
    SARLAFT_DETAIL,
    SWITCH_DETAIL,
} from '../../../../../../../routes/paths';
import type { Source } from '../types';

const routeDictionary: Record<Source, string> = {
    SWITCH: SWITCH_DETAIL,
    CASES_GENERAL_INFO: CASES_GENERAL_INFORMATION_DETAIL,
    QUOTATION: QUOTATION_DETAIL,
    SARLAFT: SARLAFT_DETAIL,
    CASES_GENERAL: CASES_GENERAL_DETAIL,
    PQR: PQR_DETAIL,
};

type Row = {
    source: Source;
    caseId?: string | null;
    sarlaftId?: string | null;
};

export function buildInteractionUrl(r: Row): string | null {
    const base = routeDictionary[r.source];
    if (!base) return null;
    const id = r.source === 'SARLAFT' ? r.sarlaftId : r.caseId;
    return id ? `${base}/${id}` : null;
}
